import { createFormContext } from '@mantine/form';
import { z } from 'zod/v4';

export const AmlFormSchema = z.object({
  caseName: z.string(),
  companyName: z.string(),
  vatNumber: z.string(),
  registeredOffice: z.string(),
  directors: z.array(z.object({ key: z.string(), name: z.string(), canBind: z.boolean() })),
  listedCompany: z.boolean(),
  beneficialOwners: z.array(z.object({ key: z.string(), name: z.string() })),
  lastName: z.string(),
  firstName: z.string(),
  address: z.string(),
  mobile: z.string(),
  email: z.string(),
  nationalNumber: z.string(),
  relationOrigin: z.string(),
  serviceDescription: z.string(),
  pep: z.string(),
  pepDetails: z.string(),
});

export type AmlFormValues = z.infer<typeof AmlFormSchema>;

export const [AmlFormProvider, useAmlFormContext] = createFormContext<AmlFormValues>();
